import { MAX_CUSTOM_DELIMITER_LENGTH, WINDOWS_1250_CHARS } from '../constants';
import { ExportEncoding } from '../types';

// A delimiter the encoder would rewrite stops matching the quoting decision, which is made before encoding.
const isDelimiterSupported = (
  delimiter: string,
  encoding: ExportEncoding
): boolean => {
  if (Array.from(delimiter).length !== MAX_CUSTOM_DELIMITER_LENGTH) {
    return false;
  }
  if (encoding === 'utf-8') return true;
  if (delimiter.charCodeAt(0) <= 0x7f) return true;

  return encoding === 'windows-1250' && delimiter in WINDOWS_1250_CHARS;
};

export default isDelimiterSupported;
